import { AppShellFrame } from '@slims/ui/organisms';
import { Outlet } from 'react-router-dom';
import { BrandingEffect } from '@/components/branding/branding-effect';
import { AppHeader } from '@/components/layout/app-header';
import { AppSidebar } from '@/components/layout/app-sidebar';
import { ProfileModal } from '@/components/modals/profile-modal';
import { useCerBrandingSync } from '@/hooks/use-cer-branding';
import { useCERConfigSync } from '@/hooks/use-cer-config';
import { useScopeSync } from '@/hooks/use-scope-sync';

/**
 * Authed app shell — ported from src/app/(app)/layout.tsx. Auth is loaded by
 * ProtectedRoute; this renders the header, the sidebar and the profile modal.
 * (next/navigation -> react-router; Suspense wrapper dropped.)
 */
export function AppShell() {
	useScopeSync();
	useCERConfigSync();
	useCerBrandingSync();

	return (
		<>
			<BrandingEffect />
			<AppShellFrame
				header={<AppHeader />}
				sidebar={<AppSidebar />}
				overlays={<ProfileModal />}
			>
				<Outlet />
			</AppShellFrame>
		</>
	);
}
